import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-hospitality-and-events',
  imports: [PillarPagesTemp],
  templateUrl: './hospitality-and-events.html',
  styleUrl: './hospitality-and-events.scss',
})
export class HospitalityAndEvents {

}
